import { Component, OnInit } from '@angular/core';
import { AgreementService } from '../../../../resources/agreement/agreement.service';
import { Agreement } from '../../../../model/agreement';

@Component({
  selector:    'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls:   [ './agreement.component.scss' ]
})
export class AgreementComponent implements OnInit {

  loading = true;
  agreement: Agreement;

  constructor(private agreementService: AgreementService) {
  }

  ngOnInit() {
    this.agreementService.get(undefined).subscribe((data) => {
      this.agreement = data;
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/settlements/agreement/agreement.component.ts